import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { Compass, Home } from 'lucide-react'
import { Button } from '../components/ui/Button'
import { useAuth } from '../contexts/AuthContext'

export function NotFoundPage() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { isAuthenticated } = useAuth()

  return (
    <div className="min-h-screen flex items-center justify-center bg-surface px-4 py-12">
      <div className="max-w-md w-full text-center">
        <div className="flex justify-center mb-6">
          <div className="rounded-full bg-muted p-4">
            <Compass className="h-12 w-12 text-muted-foreground" />
          </div>
        </div>

        <p className="text-sm font-semibold text-primary mb-2">404</p>
        <h1 className="text-2xl font-bold text-foreground mb-3">{t('notFound.title')}</h1>
        <p className="text-muted-foreground mb-8">{t('notFound.message')}</p>

        <Button
          onClick={() => navigate(isAuthenticated ? '/' : '/plans')}
          className="inline-flex items-center gap-2"
        >
          <Home className="h-4 w-4" />
          {isAuthenticated ? t('notFound.backToDashboard') : t('notFound.backToPlans')}
        </Button>
      </div>
    </div>
  )
}
